import React from "react";
import { useSearchParams } from "react-router-dom";
import LandingLayout from "./LandingLayout";
import { LegalMarkdown } from "./LegalMarkdown";
import { PLATFORM_BRAND } from "./config";
import { fmtLegalDate, useLegalDoc } from "@/lib/legal";

const TITLES = { privacy: "Privacy Policy", terms: "Terms of Service", partners: "Legal Partners" };
const TEST_IDS = { privacy: "lp-privacy", terms: "lp-terms", partners: "lp-legal-partners" };

function PartnerList({ rows }) {
  return (
    <div data-testid="lp-legal-partners-list">
      <h2>Our Legal Partners</h2>
      {rows.length ? (
        <ul>
          {rows.map((r) => (
            <li key={r.name} data-testid="lp-legal-partner-item">
              <strong>{r.name}</strong>{r.location ? ` — ${r.location}` : ""}
            </li>
          ))}
        </ul>
      ) : (
        <p data-testid="lp-legal-partners-empty">Our partner list is being updated. Contact us for the current list.</p>
      )}
    </div>
  );
}

export default function LegalPage({ kind }) {
  const [params] = useSearchParams();
  const code = params.get("b") || null;
  const { doc, error } = useLegalDoc(kind, code);
  const brand = doc && doc.brand !== PLATFORM_BRAND ? doc.brand : null;
  return (
    <LandingLayout brand={brand} buyerCode={brand ? code : null} hidePhone={Boolean(brand)}>
      <div className="lp-legal" data-testid={TEST_IDS[kind]}>
        <h1>{TITLES[kind]}</h1>
        {doc && <div className="lp-legal-updated" data-testid="lp-legal-updated">Last updated: {fmtLegalDate(doc.updated_at)}</div>}
        {error && <p data-testid="lp-legal-error">This page couldn't load. Please refresh or try again shortly.</p>}
        {!doc && !error && <p data-testid="lp-legal-loading">Loading…</p>}
        {doc && <LegalMarkdown text={doc.markdown} testId="lp-legal-body" />}
        {doc?.partners && <PartnerList rows={doc.partners} />}
        {kind === "privacy" && doc && (
          <p className="lp-legal-credit" data-testid="lp-legal-geo-credit">
            Approximate visitor location: <a href="https://db-ip.com" target="_blank" rel="noopener noreferrer">IP Geolocation by DB-IP</a>.
          </p>
        )}
      </div>
    </LandingLayout>
  );
}
